<template>
  <DropdownContent v-if="isOpen || overrideOpen" parentClass="gmf-login-cta-popup" :hideOverlay="true" @close="close">
    <template v-slot:anchor>
      <div class="gmf-login-cta-arrow" :class="{'gmf-invisible': ! hasLoaded}"></div>
    </template>
    <div class="gmf-context gmf-login-cta" :class="{'gmf-invisible': ! hasLoaded}" ref="dropdownEl">
      <img class="gmf-login-cta-image" @load="hasLoaded = true" :src="state.merchantConfig?.widgets?.loginCTA?.imageUrl">
      <div class="gmf-login-cta-list">
        <div class="gmf-login-cta-text">
          <span class="gmf-small-text" v-html="descriptionText"></span>
        </div>
      </div>
      <div class="gmf-login-cta-buttons">
        <button v-if="hasLogin" class="gmf-btn gmf-btn-primary gmf-btn-sm gmf-mt-0 gmf-center" @click="login">{{ t('login') }}</button>
        <a v-if="hasSignup" href="#" class="gmf-link gmf-mt-0" @click.prevent="signup">{{ t('signup') }}</a>
      </div>
    </div>
  </DropdownContent>
</template>

<style>
.gmf-login-cta-popup {
  filter: drop-shadow(0px 2px 4px rgba(0,0,0,.2));
}
.gmf-login-cta {
  position: relative;
  left: calc(var(--gmf-rounding) * -4);
  background: var(--gmf-col-white);
  flex-direction: column;
  display: flex;
  gap: var(--gmf-p-4);
  width: 200px;
  border-radius: var(--gmf-rounding);
  overflow: hidden;
}
.gmf-login-cta-arrow {
  position: absolute;
  transform: translate(-50%, -15%) rotate(45deg);
  left: 50%;
  width: 25px;
  aspect-ratio: 1;
  background: var(--gmf-login-cta-arrow-color);
  z-index: calc(var(--gmf-modal-z-index));
  border-radius: 2px;
}
.gmf-login-cta, .gmf-login-cta-arrow {
  transition: opacity 0.5s ease-in-out;
}
.gmf-login-cta-image {
  background: var(--gmf-login-cta-arrow-color);
}
.gmf-login-cta a {
  width: 100% !important;
  text-align: center;
}
.gmf-login-cta-text {
  padding-inline: var(--gmf-p-5);
}
.gmf-login-cta-item {
  display: flex;
  gap: var(--gmf-p-3)
}
.gmf-login-cta-buttons {
  display: flex;
  flex-direction: column;
  gap: var(--gmf-p-3);
  padding: var(--gmf-p-4);
  padding-top: 0;
}
</style>

<script>
import DropdownContent from '@/components/DropdownContent';

import md from '@/utils/md';
import state from '@/state';
import hooks from '@/utils/hooks';
import requestLogin from '@/utils/requestLogin';
import requestSignup from '@/utils/requestSignup';
import { getLocalizedString } from '@/utils/getLocalizedString';

const t = state.t.prefix('login_cta');

export default {
  name: 'LoginCTA',
  components: {
    DropdownContent,
  },
  emits: ['close'],
  props: {
    overrideOpen: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      state,
      isOpen: false,
      hasLoaded: false,
    };
  },
  methods: {
    t,
    md,
    login () {
      requestLogin();
    },
    signup () {
      requestSignup();
    },
    close () {
      this.isOpen = false;
      this.$emit('close');
    },
    handleClickOutside (event) {
      if (event.target.classList.contains('gmf-profile-dropdown-btn-icon')) {
        return;
      }
      if (! this.$refs.dropdownEl?.contains(event.target)) {
        this.close();
      }
    },
  },
  computed: {
    loginUrl () {
      return state.merchantConfig?.loginUrl || '';
    },
    hasLogin () {
      return getLocalizedString(this.loginUrl) || hooks.isRegistered('requestLogin');
    },
    hasSignup () {
      return state.merchantConfig.signupUrl || hooks.isRegistered('requestSignup');
    },
    descriptionText () {
      return md(t('description').replaceAll('\\n', '\n'));
    }
  },
  mounted () {
    if (state.merchantConfig?.widgets?.loginCTA?.enabled) {
      setTimeout(() => {
        if (! sessionStorage.getItem('gmf_has_shown_login_cta')) {
          setTimeout(() => {
            this.isOpen = true;
            sessionStorage.setItem('gmf_has_shown_login_cta', true);
          }, 300);
        }
          
        window.addEventListener('click', this.handleClickOutside);
        window.addEventListener('touchstart', this.handleClickOutside);
        window.addEventListener('scroll', this.close);
      }, 1000);
    }
  },
  unmounted () {
    window.removeEventListener('click', this.handleClickOutside);
    window.removeEventListener('touchstart', this.handleClickOutside);
    window.removeEventListener('scroll', this.close);
  },
};
</script>
  